// A new build deployed while this page was open: its lazy chunks (a drawer,
// the fleet page) are gone from the server, so opening one fails until the
// page is reloaded. index.html is always revalidated (internal/webui), so
// asking it every minute is a 304 until a deploy; once it no longer names
// the script this page runs, the status bar says so.
import { ref } from 'vue'

export const newVersion = ref(false)

// outdated: the index.html served now does not load this page's script
export const outdated = (html: string, script: string) => !!script && !html.includes(script)

export function watchUpdates() {
    const script = document.querySelector('script[type=module][src]')?.getAttribute('src') ?? ''
    const check = async () => {
        if (newVersion.value) return
        try {
            const r = await fetch('/', { cache: 'no-cache' })
            if (r.ok && outdated(await r.text(), script)) newVersion.value = true
        } catch {
            /* the server is away: the connection dot says so, try again next time */
        }
    }
    setInterval(() => void check(), 60_000)
    // a lazy chunk failed to load (Vite's event): ask now, not in a minute
    window.addEventListener('vite:preloadError', () => void check())
}
